import { useCallback } from "react";
import { useNavigate } from "react-router";
import { logout } from "@/src/auth/services/auth-http.service";
import { signOut } from "@/src/common/redux/session-slice";
import { useAppDispatch } from "@/src/common/redux/store";
import { clearTokens, getRefreshToken } from "@/src/common/services/token-store.service";

export const useLogout = () => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	return useCallback(async () => {
		try {
			const refreshToken = await getRefreshToken();
			if (refreshToken) {
				await logout(refreshToken);
			}
		} catch {
			// a failed network logout must not block clearing the local session
		} finally {
			await clearTokens();
			dispatch(signOut());
			navigate("/login", { replace: true });
		}
	}, [dispatch, navigate]);
};
